import React from 'react';
import { DSControlledCheckbox } from '@elliemae/ds-form-checkbox';
import { useGetGlobalAttributes } from '@elliemae/ds-props-helpers';
import { StyledContainer } from './style.js';
interface MobileListMultipleItemT {
  title: string;
  value: string;
  isSelected: boolean;
}
export const MobileListMultipleItem: React.ComponentType<MobileListMultipleItemT> = (props) => {
  const { title, isSelected } = props;
  const { onClick, ...rest } = useGetGlobalAttributes(props);
  return (
    <StyledContainer
      cols={['auto']}
      minHeight="40px"
      width="100%"
      pl="16px"
      pr="16px"
      gutter="xs"
      alignItems="center"
      {...rest}
    >
      <DSControlledCheckbox onChange={onClick} device="mobile" checked={isSelected} label={title} wrapLabel />
    </StyledContainer>
  );
};
